<script>
if (window.jQuery) {
  require('sticky-kit/dist/sticky-kit.js')
}

import Locator from '../../common/components/locator/Locator.vue'
import Newsfeed from '../../common/components/Newsfeed.vue'

export default {
  components: {
    Locator,
    Newsfeed,
  },

  mounted() {
    let baseline = parseInt(
        window.getComputedStyle(document.body).getPropertyValue('font-size')
      ),
      nav = document.querySelector('.region-navigation')

    let sticky = window.jQuery('.product__sticky')
    if (sticky.length) {
      window.jQuery('.product__sticky').stick_in_parent({
        offset_top: nav.offsetHeight + baseline,
      })
    }
  },
  methods: {
    manageProductSticky: function() {
      let $sticky = $(this.$el).find('.product__sticky')
      let $sidebar = $(this.$el).find('.product__sidebar')
      let bbSticky = $sticky.get(0).getBoundingClientRect()
      let stickyHeight = bbSticky.top + bbSticky.height
      if (stickyHeight > $(window).height()) {
        $sticky.removeClass('product__sticky--stick')
        $sidebar.addClass('product__sidebar--small')
        return
      }

      $(window).on('scroll', () => {
        let bbSidebar = $sidebar.get(0).getBoundingClientRect()
        let sidebarHeight = bbSidebar.top + bbSidebar.height
        if (sidebarHeight < stickyHeight + 40) {
          $sticky.removeClass('product__sticky--stick')
        } else {
          $sticky.addClass('product__sticky--stick')
        }
      })
    },
  },
}
</script>


<style lang="sass">

@import ../../common/styles/settings
@import ../../common/styles/mixins

.page--product

    .breadcrumbs
        position: static
        top: 0
        margin-bottom: $baseline
        margin-left: 0

    .locator
        margin-top: 0
        padding-top: $baseline
        background: none
        +media('>=xsmall')
            padding-bottom: $baseline

        &__content
            width: 100%

        .title--2
            font-size: 1.75rem

        &.section--inside
            +media('>=xsmall', '<medium')
                margin-left: -$baseline
            +media('>=medium', '<large')
                margin-left: 0

    .wrapper
        position: relative
        // &::before
        //     +pseudo
        //     background: darken($color-background-light, 5%)
        //     +media('<xsmall')
        //         height: $baseline*20
        //         background-position: center $baseline*2
        //         background-size: 120% auto
        //     +media('>=xsmall')
        //         left: auto
        //         right: calc(50% + 1.25rem)
        //         background-position: right bottom
        //         background-size: 50% auto

        +media('<=xsmall')
            padding-right: $baseline
            padding-left: $baseline

.product

    &__content
        > .container
            overflow: hidden
            +media('>medium')
                width: 77.5rem

        &::before
            z-index: 0
            position: fixed

    &__sidebar
        min-height: 400px
        +media('>=xsmall', '<large')
            padding-left: 5%

        +media('>large')
            display: flex
            flex-direction: column
            padding-bottom: 2rem
            &--small
                justify-content: flex-start

    &__sticky
        transition: top $speed-fast $authentic-motion
        padding: $baseline*3 0 $baseline*2
        +media('>large')
            width: 500px !important

    &__faq
        +media('<xsmall')
            background-color: $color-background-light
        .faq
            +media('<xsmall')
                background-color: darken($color-background-light, 5%)

@import ./product_accessories
@import ./product_cross
@import ./product_caption
@import ./product_details
@import ./product_howto
@import ./product_preview
</style>
